import React from 'react'
import Layout from '../../component/Layout';
import FeaturesContent from '../../component/FeaturesContent';
import { t } from 'i18next';

const FeaturesContainer = () => {
	return (
		<Layout title={t("features")} description={t("features_desc")}>
			<FeaturesContent />
		</Layout>
	)
}

export default FeaturesContainer